import * as React from 'react';
import { get } from 'lodash';
import { Field } from 'redux-form';
import { FormRadioButtonGroup } from '@inqool/uas-web-core/es/components/controls/RadioGroup';

import * as T from '@components/form/RadioSwitch/_radioSwitchTypes';

const RadioSwitch: React.SFC<any> = ({ label1, label2, ...props }) => {
  const item1 = { value: true, label: label1 };
  const item2 = { value: false, label: label2 };
  const items = [item1, item2];

  return (
    <FormRadioButtonGroup
      items={items}
      labelFunction={o => get(o, 'label')}
      valueFunction={o => get(o, 'value')}
      {...props}
    />
  );
};

export default RadioSwitch;

export class RadioSwitchField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/RadioSwitch/RadioSwitch.tsx